import { FormTextarea } from 'src/components/common/Forms/FormTextarea'
import { InvoiceFormInputs } from './InvoiceEditForm'
import InvoiceEditorSection from './InvoiceEditorSection'

export const INVOICE_PREVIEW_COLS_AT_ROW = 62
export const InvoiceRemarks = () => {
  return (
    <InvoiceEditorSection title="備考" number={6}>
      <FormTextarea<InvoiceFormInputs>
        lineHeight="1.5"
        rows={3}
        cols={INVOICE_PREVIEW_COLS_AT_ROW}
        placeholder="特筆するべきことがあれば記載してください。"
        label="備考"
        w="420px"
        name="remarks"
      />
    </InvoiceEditorSection>
  )
}
